import { gql } from '@apollo/client';

export const getAttachmentUploadUrlMutation = gql`
  mutation GetAttachmentUploadUrlForUser(
    $attachment: GetAttachmentUploadUrlRequest!
  ) {
    getAttachmentUploadUrlForUser(attachment: $attachment) {
      url
      fields
    }
  }
`;

export const saveAttachmentMutation = gql`
  mutation SaveAttachmentForUser($attachment: SaveAttachmentInput!) {
    saveAttachmentForUser(attachment: $attachment) {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      uploaded
      processed
      attachedTo
      createdAt
      updatedAt
    }
  }
`;

export const saveProfilePhotoMutation = gql`
  mutation SaveProfilePhotoForUser($profilePhoto: SaveProfilePhotoInput!) {
    saveProfilePhotoForUser(profilePhoto: $profilePhoto) {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      uploaded
      processed
      profilePhotoFor
      createdAt
      updatedAt
    }
  }
`;
